// B2B Layout with Header and Footer - AIAgentify Voyager
import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useB2B } from '../context/B2BContext';
import B2BSidebar from './B2BSidebar';

export default function B2BLayout() {
  const { agency, loading, token } = useB2B();
  const navigate = useNavigate();
  const [newLeadsCount, setNewLeadsCount] = useState(0);

  useEffect(() => {
    if (!loading && !token) {
      navigate('/login');
    }
  }, [loading, token, navigate]);

  useEffect(() => {
    async function fetchNewLeads() {
      if (!token) return;
      try {
        const res = await fetch('/api/b2b/leads?status=new&count_only=true', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (res.ok) {
          const data = await res.json();
          setNewLeadsCount(data.count || 0);
        }
      } catch (err) {
        console.error('Failed to fetch new leads count');
      }
    }
    fetchNewLeads();
    const interval = setInterval(fetchNewLeads, 60000);
    return () => clearInterval(interval);
  }, [token]);

  if (loading) {
    return (
      <div className="b2b-loading">
        <div className="b2b-loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!token) return null;

  return (
    <div className="b2b-layout">
      <header className="b2b-header">
        <div className="b2b-header-content">
          <div className="b2b-header-logo">
            <img 
              src="/voyager-icon.svg" 
              alt="Voyager" 
              style={{ height: '32px', marginRight: '10px' }}
            />
            <span className="b2b-header-logo-text">AIAgentify Voyager</span>
          </div>
          <div className="b2b-header-right">
            {agency && (
              <div className="b2b-header-agency">
                <span className="b2b-header-agency-name">{agency.name}</span>
                <span className="b2b-header-agency-plan">
                  {agency.subscription_plan === 'starter' ? 'Starter' :
                   agency.subscription_plan === 'pro' ? 'Pro' :
                   agency.subscription_plan === 'enterprise' ? 'Enterprise' : 'Free Plan'}
                </span>
              </div>
            )}
          </div>
        </div>
      </header>

      <div className="b2b-body">
        <B2BSidebar newLeadsCount={newLeadsCount} />
        <main className="b2b-main">
          <Outlet />
        </main>
      </div>

      <footer className="b2b-footer">
        <div className="b2b-footer-content">
          <span>Powered by</span>
          <a href="https://aiagentify.net" target="_blank" rel="noopener noreferrer">
            <strong>AIAgentify Voyager</strong>
          </a>
          <span className="b2b-footer-divider">•</span>
          <span>© {new Date().getFullYear()}</span>
        </div>
      </footer>
    </div>
  );
}
